export class Toggle {
    constructor(element) {
        this.element = $(element);
        this.target = $(this.element.data('target'));

        if (!this.target || this.target.length <= 0) {
            return;
        }

        if (this.element.data('offclick')) {
            this.element.off('click');
        }

        this.element.on('click', (event) => this.onClick.call(this, event));
    }
    onClick(event) {
        event.preventDefault();

        this.element.trigger('mario.toggle.before', [this]);

        this.target.toggleClass('active');

        if (this.element.data('scroll') === true) {
            scrollToTop();
        }

        this.toggleText();

        this.element.trigger('mario.toggle.after', [this]);
    }
    toggleText() {
        let
            newText = this.element.data('text'),
            oldText = this.element.text();

        if (!newText) {
            return;
        }

        this.element.text(newText);
        this.element.data('text', oldText);
    }
}
